import type { IValidator } from './Validators';

export interface IImportOption {
    text: string;
    value: string | null;
    validation: IValidator | null;
    automap: string[] | null;
    options: IImportOption[] | null;
    column: string | null;
    visible?: boolean;
}

export class ImportOption implements IImportOption {
    text: string;
    value: string | null;
    validation: IValidator | null;
    automap: string[] | null;
    options: IImportOption[] | null;
    column: string | null;
    visible?: boolean;

    constructor(
        text: string,
        value: string | null = null,
        validation: IValidator | null = null,
        automap: string[] | null = null,
        options: IImportOption[] | null = null,
        column: string | null = null,
        visible: boolean = true,
    ) {
        this.text = text;
        this.value = value;
        this.validation = validation;
        this.automap = automap;
        this.options = options;
        this.column = column;
        this.visible = visible;
    }
}
